<template>
  <SinglePlanLayout
    :heading=" $t('subscription.pro_light_only.heading')"
    :features="features"
  />
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import SinglePlanLayout from './SinglePlanLayout.vue';

const { t } = useI18n();

const features = [
  {
    icon: 'calendar',
    title: t('subscription.pro_light_only.calendar.heading'),
    features: [
      t('subscription.pro_light_only.calendar.feature1'),
      t('subscription.pro_light_only.calendar.feature2'),
      t('subscription.pro_light_only.calendar.feature3'),
      t('subscription.pro_light_only.calendar.feature4'),
    ],
    visual: '/img/subscription/salon.svg',
  },
  {
    icon: 'briefcase',
    title: t('subscription.pro_light_only.efficiency.heading'),
    features: [
      t('subscription.pro_light_only.efficiency.feature1'),
      t('subscription.pro_light_only.efficiency.feature2'),
      t('subscription.pro_light_only.efficiency.feature3'),
      t('subscription.pro_light_only.efficiency.feature4'),
    ],
    visual: '/img/subscription/register-prolight.svg',
  },
  {
    icon: 'marketing',
    title: t('subscription.pro_light_only.marketing.heading'),
    features: [
      t('subscription.pro_light_only.marketing.feature1'),
      t('subscription.pro_light_only.marketing.feature2'),
      t('subscription.pro_light_only.marketing.feature3'),
      t('subscription.pro_light_only.marketing.feature4'),
    ],
    visual: '/img/subscription/newsletter.svg',
  },
];
</script>
